import { Component } from '@angular/core';
import {Vector3} from "three";
import {Store} from "@ngrx/store";
import {ActivatedRoute, EventType, Router} from "@angular/router";
import {InputService} from "../../binst/inputs/services/input.service";
import {IconsService} from "../../services/icons.service";
import {selectCameraTarget, selectCameraZoomTarget} from "../../state/camera/camera.selector";
import {cameraActions} from "../../state/camera/camera.actions";
import {selectConnected, selectNotResponsive, selectSlow} from "../../state/network/network.selector";
import * as AuthSelectors from "../../state/auth/auth.selector";
import * as ChatSelectors from "../../state/chats/chat.selector";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgForOf, NgIf} from "@angular/common";
import faIcons from "@fortawesome/free-solid-svg-icons";
import {interfaceActions} from "../../state/interface/interface.actions";

@Component({
  selector: 'toolbar-actions',
  standalone: true,
  imports: [
    FaIconComponent,
    NgForOf,
    NgIf
  ],
  templateUrl: './toolbar-actions.component.html',
  styleUrl: './toolbar-actions.component.scss'
})
export class ToolbarActionsComponent {

  cameraTarget: Vector3

  coordX: string
  coordY: string
  coordXList: string[]
  coordYList: string[]
  zoomDisplay: string
  zoomTarget: number

  zoomLevels = [300, 500, 1200, 3000, 7000, 50000]

  leftPaneActive: boolean = false;
  rightPaneActive: boolean = false;
  unreadMessageCount = 0
  unreadMessageCountSubscription = null

  networkConnected: boolean
  networkSlow: boolean
  networkNotResponsive: boolean


  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private inputService: InputService,
      public iconsService: IconsService
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.coordX = Math.round(target.x) + ""
      this.coordXList = this.coordX.split('')
      this.coordY = Math.round(target.y) + ""
      this.coordYList = this.coordY.split('')
      this.coordXList = [
        ...Array(4 - this.coordXList.length).fill(''),
        ...this.coordXList
      ]
      this.coordYList = [
        ...this.coordYList,
        ...Array(4 - this.coordYList.length).fill(''),
      ]
    })
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      this.zoomDisplay = Math.round(Math.sqrt(target)/5) + ""
      // this.zoomDisplay = Math.round(target) + ""
      this.zoomTarget = target
    })
    this.router.events.subscribe((event) => {
      this.checkIfPanesActive()
      if (event.type === EventType.NavigationEnd) {
        this.store.dispatch(
            cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
        );
      }
    })
    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      if (!user) return;
      if (this.unreadMessageCountSubscription) this.unreadMessageCountSubscription.unsubscribe();
      this.unreadMessageCountSubscription = this.store.select(
          ChatSelectors.selectTotalUnreadMessagesForUser(user.id)
      ).subscribe((count) => {
        this.unreadMessageCount = count
      })
    })
    this.store.select(selectConnected).subscribe((connected) => {
      if (connected === null) return;
      this.networkConnected = connected
    })
    this.store.select(selectSlow).subscribe((isSlow) => {
      if (isSlow === null) return;
      this.networkSlow = isSlow
    })
    this.store.select(selectNotResponsive).subscribe((isNoResponse) => {
      if (isNoResponse === null) return;
      this.networkNotResponsive = isNoResponse
    })
  }


  checkIfPanesActive() {
    const leftPaneRoute = this.route.children.find(
        child => child.outlet === 'left-pane'
    );
    const rightPaneRoute = this.route.children.find(
        child => child.outlet === 'right-pane'
    );
    this.leftPaneActive = !!leftPaneRoute
    this.rightPaneActive = !!rightPaneRoute
  }

  goHome() {
    this.store.dispatch(cameraActions.targetJumped({
      target: new Vector3(0,0,500)
    }))
  }

  rewind() {
    this.store.dispatch(cameraActions.rewindTarget())
  }

  createNewEmoji() {
    this.router.navigate([{outlets: {'new-modal-pane': "new-map-reaction"}}])
  }


  openChats() {
    if (!this.leftPaneActive) {
      this.router.navigate([{outlets: {'left-pane': "chat-bar"}}])
    } else {
      this.router.navigate([{outlets: {'left-pane': null}}])
    }
  }

  zoomOut() {
    this.store.dispatch(cameraActions.zoomJumped({
      absoluteZoom: 7000
    }))
  }

  changeZoom() {
    let nextZoomLevel = 0
    for (let i = 0; i < this.zoomLevels.length; i++) {
      if (this.zoomLevels[i] > this.zoomTarget - 1) {
        break
      }
      nextZoomLevel = this.zoomLevels[i]
    }
    if (this.zoomTarget > (this.zoomLevels[0] - 1) && this.zoomTarget < (this.zoomLevels[0] + 1)) {
      nextZoomLevel = this.zoomLevels[this.zoomLevels.length - 1]
    }
    this.store.dispatch(cameraActions.zoomJumped({
      absoluteZoom: nextZoomLevel, jumpTimeMs: 300
    }))
  }


  createNewItem() {
    this.router.navigate([{outlets: {'new-modal-pane': "new-flyer"}}])
    // this.store.dispatch(interfaceActions.openContextMenu())
    // const pointerPos = this.inputService.getLastPointerPosition()
    // this.router.navigate(
    //     [{outlets: {'context-menu': "context-new-select"}}],
    //     {
    //       queryParams: {
    //         posX: pointerPos.x - 100,
    //         posY: pointerPos.y - 50
    //       },
    //       queryParamsHandling: 'merge' // optional but common
    //     })
  }

}
